import { createRouter, createWebHistory } from 'vue-router';
import { routes } from '@/routes/routes';
import * as authFunctions from '@/helpers/authFunctions.js';
import { useApplicationStore } from '@/stores/applicationStore.js';
import { findRouteByStep, findFinalPageRoute } from '@/helpers/steps';

const router = createRouter({
    history: createWebHistory('/my/pre-qualify'),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        // Always scroll to top
        return { top: 0 };
    }
});

const isRoutePartOfWizard = (route) => {
    if (!route) return false;

    return (
        route.startsWith('home-buying') ||
        route.startsWith('home-buy-sell') ||
        route.startsWith('home-sell') ||
        route.startsWith('refinance')
    );
};

router.beforeEach(async (to, from, next) => {
    const applicationStore = useApplicationStore();

    if (authFunctions.isLoggedIn()) {
        const restrictedRoutes = ['new-account', 'create-account', 'auth.login'];

        if (to.name && restrictedRoutes.some((route) => to.name.includes(route))) {
            next('/profile');
        }
    }

    if (to.name === 'profile') {
        if (!authFunctions.isLoggedIn()) {
            next('/profile/login');
        }
    }

    // We want to clear the application if the user comes from the profile or directly to the apply now page
    // if (
    //     (!from.name && to.name === 'apply-now.index') ||
    //     (from.name === 'profile' && to.name === 'apply-now.index')
    // ) {
    //     applicationStore.clearStore();
    // }

    // First there needs to be an application loaded in the store
    // Redirect the user to the final page of the application if application is finished
    // because he shouldn't be able to update the application anymore
    // and we should not be on the sell flow
    if (
        authFunctions.isLoggedIn() &&
        applicationStore.application.id > 0 &&
        !applicationStore.application.active &&
        isRoutePartOfWizard(to?.name) &&
        applicationStore.application.workflow !== 3 &&
        !((to.name ?? '').includes('success') || (to.name ?? '').includes('need-more-info'))
    ) {
        const route = findFinalPageRoute(
            applicationStore?.application?.workflow,
            applicationStore?.application?.approved
        );

        if (to.name !== route.name) {
            next(route);
            return;
        }
    }

    if (
        window.location.hostname !== 'pqworkflow.loc' &&
        window.location.hostname !== 'www.qaguidanceresidentialqa.com'
    ) {
        const workflow_step = applicationStore.application?.workflow_step;
        const routeIsStep = isRoutePartOfWizard(to?.name);

        const routeIsMainPage =
            to.name === 'home-buying.index' ||
            to.name === 'home-buy-sell.index' ||
            to.name === 'refinance.index' ||
            to.name === 'home-sell.index';

        const finalRoutes = ['success', 'need-more-info'];
        const isFinalPage = finalRoutes.some((route) => to.name.includes(route));

        if (
            (from.name === undefined || from.name === 'profile') &&
            !routeIsMainPage &&
            routeIsStep &&
            !isFinalPage
        ) {
            const route = findRouteByStep(workflow_step);

            if (!route || !route.route) {
                console.warn('No valid route found for workflow_step:', workflow_step);
                next();
                return;
            }

            // Prevent infinite redirection by checking if we are already on the target route
            if (to.path !== route.route) {
                next(route.route);
            } else {
                next();
            }
        } else {
            next();
        }
    } else {
        next();
    }
});

export { router };
